"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _lodash = _interopRequireDefault(require("lodash"));

var _conf = _interopRequireDefault(require("../../conf"));

var _user = _interopRequireDefault(require("../user/user"));

var _farm = _interopRequireDefault(require("../farm/farm"));

var _index = _interopRequireDefault(require("../brunch/index"));

var _projectState = _interopRequireDefault(require("../project-state"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _translate = _interopRequireDefault(require("../translate"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _farmComment = _interopRequireDefault(require("./../farm-comment"));

var _deleteButtonProject = _interopRequireDefault(require("./../delete-button-project"));

var _gitChangesetLink = _interopRequireDefault(require("../git-changeset-link"));

var _projectStatus = _interopRequireDefault(require("../project-status"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var DeleteButtonAuthorised = new _authorisation.default(['admin', 'projectresponsible'], ['brunch'], false)(_deleteButtonProject.default);
var invalidFieldsDefault = {
  brunch: {
    fields: {},
    details: {}
  },
  brunchforeignorganisator: {
    fields: {},
    details: {}
  }
};

var Release = /*#__PURE__*/function (_React$Component) {
  _inherits(Release, _React$Component);

  function Release(props) {
    var _this;

    _classCallCheck(this, Release);

    _this = _possibleConstructorReturn(this, (Release.__proto__ || Object.getPrototypeOf(Release)).call(this, props));
    _this.state = {
      subMenuConfig: [{
        label: props.t('status'),
        anchor: 'status'
      }, {
        label: props.t('User'),
        anchor: 'user-data'
      }, {
        label: props.t('farm'),
        anchor: 'farm-data'
      }, {
        label: props.t('Projectdata'),
        anchor: 'project-data'
      }, {
        label: props.t('Projects'),
        anchor: 'other-projects'
      }],
      userLoaded: false,
      user: {},
      project: null,
      farm: null,
      projectLoaded: false,
      sponsoringAnswers: {},
      questionIdFieldNameMap: [],
      salutations: [],
      cantons: [],
      placedetails: [],
      languages: [],
      sponsoringQuestions: [],
      paymentmethod: [],
      organisatorTypes: [{
        id: 1,
        value: props.t('own address')
      }, {
        id: 3,
        value: props.t('other address')
      }],
      locationTypes: [{
        id: 1,
        value: props.t('own farm')
      }, {
        id: 3,
        value: props.t('other farm')
      }],
      isSaving: false,
      invalidFields: _lodash.default.cloneDeep(invalidFieldsDefault),
      error: '',
      success: false,
      changeSet: '',
      images: [],
      documents: []
    };

    if (props.getSubMenuConfig && _this.state.subMenuConfig) {
      props.getSubMenuConfig(_this.state.subMenuConfig);
    }

    _this.updateBrunchState = _this.updateBrunchState.bind(_assertThisInitialized(_this));
    _this.updateSponsoringAnswers = _this.updateSponsoringAnswers.bind(_assertThisInitialized(_this));
    _this.updateBrunchForeignOrganisator = _this.updateBrunchForeignOrganisator.bind(_assertThisInitialized(_this));
    _this.saveBrunch = _this.saveBrunch.bind(_assertThisInitialized(_this));
    _this.deleteForeignorganisator = _this.deleteForeignorganisator.bind(_assertThisInitialized(_this));
    _this.projectAfterLoad = _this.projectAfterLoad.bind(_assertThisInitialized(_this));
    _this.updateSponsoringQuestionOnProject = _this.updateSponsoringQuestionOnProject.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.updateSingleField = _this.updateSingleField.bind(_assertThisInitialized(_this));
    _this.updateFarmData = _this.updateFarmData.bind(_assertThisInitialized(_this));
    _this.onFileUpload = _this.onFileUpload.bind(_assertThisInitialized(_this));
    _this.onFileRemove = _this.onFileRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Release, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var farmId = this.props.match.params.farmId;
      fetch(_conf.default.api.brunchApiUrlTemplate(this.props.i18n.language, farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (project) {
        _this2.setState(function (prev) {
          project = _this2.projectAfterLoad(project);
          prev.changeSet = project.changeSet;
          prev.project = project;
          prev.projectLoaded = true;
          prev.sponsoringAnswers = Release.getAnswersMap(project);
          prev.questionIdFieldNameMap = Release.getIdQuestionFieldMap(project);
          prev.images = project.images;
          prev.documents = project.documents;
          return prev;
        });
      }).then(function () {
        fetch(_conf.default.api.salutationApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (salutations) {
          _this2.setState(function (prev) {
            prev.salutations = salutations;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
        fetch(_conf.default.api.cantonApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (cantons) {
          _this2.setState(function (prev) {
            prev.cantons = cantons;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
        fetch(_conf.default.api.placedetailsApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (placedetails) {
          _this2.setState(function (prev) {
            prev.placedetails = placedetails;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
        fetch(_conf.default.api.correspondenceLanguageApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (languages) {
          _this2.setState(function (prev) {
            prev.languages = languages;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
        fetch(_conf.default.api.sponsoringQuestions(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (sponsoringQuestions) {
          _this2.setState(function (prev) {
            prev.sponsoringQuestions = sponsoringQuestions;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
        fetch(_conf.default.api.paymentMehtodApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (paymentmethod) {
          _this2.setState(function (prev) {
            prev.paymentmethod = paymentmethod;
            return prev;
          });
        }).catch(function (err) {
          void 0;
        });
      }).catch(function (err) {
        if (err.error.status === 404) {
          _this2.props.history.push('/not-found');
        }
      });
      fetch("".concat(_conf.default.api.farmApiUrlTemplate(this.props.i18n.language), "/").concat(parseInt(farmId)), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (farm) {
        _this2.setState(function (prev) {
          Object.keys(farm).map(function (farmProp) {
            if (farm[farmProp] === null || farm[farmProp] === 'undefined') {
              farm[farmProp] = '';
            }
          });
          prev.farm = farm;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch(_conf.default.api.userFromFarmApiUrlTemplate(this.props.i18n.language, farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (user) {
        _this2.setState(function (prev) {
          prev.user = user;
          prev.userLoaded = true;
          return prev;
        });
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var farmId = this.props.match.params.farmId;
      var _this$props = this.props,
          projects = _this$props.projects,
          role = _this$props.role;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-brunch-release detail-view"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, t('1st of august brunch'), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-list"
      }, /*#__PURE__*/_react.default.createElement(DeleteButtonAuthorised, {
        id: parseInt(this.props.match.params.farmId),
        history: this.props.history,
        urlTemplate: _conf.default.api.brunchApiUrlTemplate
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "status"
      }, t('release status')), /*#__PURE__*/_react.default.createElement(_projectState.default, {
        projectKey: 'brunch',
        farmId: this.props.match.params.farmId,
        projectData: this.state.project
      }), /*#__PURE__*/_react.default.createElement(_gitChangesetLink.default, {
        changesetUrl: this.state.changeSet,
        text: t('Brunch changeset link')
      }), /*#__PURE__*/_react.default.createElement(_farmComment.default, {
        id: parseInt(this.props.match.params.farmId)
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.userLoaded && /*#__PURE__*/_react.default.createElement(_user.default, {
        name: "User",
        user: this.state.user,
        anchorId: this.state.subMenuConfig[1].anchor
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.farm ? /*#__PURE__*/_react.default.createElement(_farm.default, {
        name: "Farm",
        farm: this.state.farm,
        id: this.props.match.params.farmId,
        anchorId: this.state.subMenuConfig[2].anchor,
        updateFarmData: this.updateFarmData,
        t: this.props.t
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader loader--medium"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.projectLoaded && this.state.farm ? /*#__PURE__*/_react.default.createElement(_index.default, {
        name: "Project",
        farm: this.state.farm,
        id: this.props.match.params.farmId,
        project: this.state.project,
        anchorId: this.state.subMenuConfig[3].anchor,
        sponsoringAnswers: this.state.sponsoringAnswers,
        questionIdFieldNameMap: this.state.questionIdFieldNameMap,
        cantons: this.state.cantons,
        locationTypes: this.state.locationTypes,
        languages: this.state.languages,
        organisatorTypes: this.state.organisatorTypes,
        placedetails: this.state.placedetails,
        salutations: this.state.salutations,
        paymentmethod: this.state.paymentmethod,
        sponsoringQuestions: this.state.sponsoringQuestions,
        history: this.props.history,
        updateProject: this.updateBrunchState,
        updateSponsoringAnswers: this.updateSponsoringAnswers,
        updateBrunchForeignOrganisator: this.updateBrunchForeignOrganisator,
        saveData: this.saveBrunch,
        updateSingleField: this.updateSingleField,
        isSaving: this.state.isSaving,
        organisatortype: [{
          id: 1,
          name: 'Eigene Adresse'
        }, //{id: 2, name: 'Adresse aus Verzeichnis'},TODO not implemented yet
        {
          id: 3,
          name: 'Andere Adresse'
        }],
        locationtype: [{
          id: 1,
          name: 'Eigener Hof'
        }, //{id: 2, name: 'Anderer Hof'},TODO not implemented yet
        {
          id: 3,
          name: 'Anderer Hof'
        }],
        invalidFields: this.state.invalidFields,
        error: this.state.error,
        success: this.state.success,
        imageUploadUrl: _conf.default.api.brunchApiAddImage(this.props.i18n.language, farmId, this.state.project.id),
        fileUploadUrl: _conf.default.api.brunchApiAddDocument(this.props.i18n.language, farmId, this.state.project.id),
        onFileUpload: this.onFileUpload,
        onFileRemove: this.onFileRemove,
        images: this.state.images,
        documents: this.state.documents,
        status: {
          status: this.getBrunchStatus(role, projects)
        }
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader loader--medium"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x grid-padding-x'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell small-12 medium-12 large-11 xlarge-10'
      }, this.state.userLoaded && /*#__PURE__*/_react.default.createElement(_projectStatus.default, {
        userId: this.state.user.id,
        t: t,
        i18n: this.props.i18n,
        history: this.props.history,
        anchorId: 'other-projects',
        ignoreProject: 'brunch'
      }))));
    }
    /**
     *
     * @param type
     * @param id
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(type, id, fieldName, value) {
      var changeTypeArray = this.state[type];

      var firstIndex = _lodash.default.findIndex(changeTypeArray, {
        id: id
      });

      this.setState(function (prev) {
        prev[type][firstIndex][fieldName] = value;
        return prev;
      });
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "updateBrunchState",
    value: function updateBrunchState(fieldName, value) {
      this.setState(function (prev) {
        _lodash.default.set(prev.project, fieldName, value);

        return prev;
      });
    }
    /**
     *
     */

  }, {
    key: "updateSponsoringAnswers",
    value: function updateSponsoringAnswers(questionId, answerObject) {
      var _this3 = this;

      this.setState(function (prev) {
        prev.sponsoringAnswers[questionId] = answerObject;
        return prev;
      }, function () {
        _this3.updateSponsoringQuestionOnProject(_this3.state);
      });
    }
    /**
     *
     * @param fieldName
     * @param value
     * @returns {Promise<Response | never>}
     */

  }, {
    key: "updateBrunchForeignOrganisator",
    value: function updateBrunchForeignOrganisator(fieldName, value) {
      var _this4 = this;

      return fetch(_conf.default.api.brunchForeignOrganisatorsApiTemplate(this.props.i18n.language), {
        credentials: 'include',
        method: 'POST'
      }).then(_fetchUtils.default.checkStatus).then(function (foreignOrganisator) {
        _this4.setState(function (prev) {
          prev.project.foreignorganizator = foreignOrganisator;
          prev.project[fieldName] = value;
          return prev;
        });
      }).catch(console.error);
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "updateSingleField",
    value: function updateSingleField(fieldName, value) {
      var _this5 = this;

      this.setState({
        isSaving: true
      }, function () {
        var body = _defineProperty({}, fieldName, value);

        return fetch(_conf.default.api.brunchApiUrlTemplate(_this5.props.i18n.language, _this5.props.match.params.farmId), {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          _this5.resetSaveError(function () {
            _this5.setState(function (prev) {
              prev.success = true;
              prev.isSaving = false;
              prev.project = _this5.projectAfterLoad(response);
              prev.sponsoringAnswers = Release.getAnswersMap(prev.project);
              return prev;
            });
          });
        }).catch(function (err) {
          _this5.handleSaveErrors(err);

          void 0;
        });
      });
    }
    /**
     *
     */

  }, {
    key: "saveBrunch",
    value: function saveBrunch() {
      var _this6 = this;

      this.setState({
        isSaving: true
      }, function () {
        _this6.deleteForeignorganisator().then(function () {
          var project = _lodash.default.cloneDeep(_this6.state.project);

          delete project.farm;

          if (_lodash.default.get(project, 'organisatortype.id') && _lodash.default.get(project, 'organisatortype.id') !== 3) {
            delete project.farmforeignorganizator;
            delete project.foreignorganizator;
          }

          delete project.images;
          delete project.documents;
          return fetch(_conf.default.api.brunchApiUrlTemplate(_this6.props.i18n.language, _this6.props.match.params.farmId), {
            method: 'PUT',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(project)
          });
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          _this6.resetSaveError(function () {
            _this6.setState(function (prev) {
              prev.success = true;
              prev.isSaving = false;
              prev.project = _this6.projectAfterLoad(response);
              prev.sponsoringAnswers = Release.getAnswersMap(prev.project);
              return prev;
            });
          });
        }).catch(function (err) {
          _this6.handleSaveErrors(err);

          void 0;
        });
      });
    }
    /**
     *
     * @returns {Promise<Response | never>}
     */

  }, {
    key: "deleteForeignorganisator",
    value: function deleteForeignorganisator() {
      var orgType = _lodash.default.get(this.props, 'project.organisatortype.id');

      if ((orgType === 1 || orgType === 2) && _lodash.default.get(this.props, 'project.foreignorganizator.id') != null) {
        return fetch(_conf.default.api.brunchForeignOrganisatorApiTemplate(this.props.i18n.language, _lodash.default.get(this.props, 'project.foreignorganizator.id')), {
          credentials: 'include',
          method: 'DELETE'
        }).then(_fetchUtils.default.checkStatus);
      }

      return Promise.resolve();
    }
    /**
     *
     * @param project
     */

  }, {
    key: "projectAfterLoad",
    value: function projectAfterLoad(project) {
      project = Release.removeEmptySingleRelation(project); // set default values

      if (!project.farmforeignorganisator) project.farmforeignorganizator = {
        id: -1
      };
      if (!project.ownforeignorganizator) project.ownforeignorganizator = {
        id: -1
      };
      project.organisatortype = this.state.organisatorTypes.filter(function (element) {
        return element.id === project.organisatortype;
      })[0] || {};
      project.locationtype = this.state.locationTypes.filter(function (element) {
        return element.id === project.locationtype;
      })[0] || {};
      project.placedetails = project.placedetails.map(function (entry) {
        return {
          id: entry.id,
          name: entry.description
        };
      });
      return project;
    }
    /**
     *
     * @param response
     */

  }, {
    key: "handleSaveErrors",
    value: function handleSaveErrors(response) {
      var _this7 = this;

      var message = response.message;
      var context = _lodash.default.get(response, 'details.context') || 'brunch';
      this.resetSaveError(function () {
        if (response.status === 422) {
          var fields = _lodash.default.get(response, 'details.codes', {});

          _this7.setState(function (prev) {
            prev.invalidFields[context] = {
              fields: Object.keys(fields),
              details: fields
            };
            prev.error = message;
            prev.success = false;
            prev.isSaving = false;
            return prev;
          });
        }
      });
    }
    /**
     *
     */

  }, {
    key: "resetSaveError",
    value: function resetSaveError(cb) {
      this.setState(function (prev) {
        prev.invalidFields = _lodash.default.cloneDeep(invalidFieldsDefault);
        prev.error = '';
        return prev;
      }, cb);
    }
    /**
     *
     * @param project
     */

  }, {
    key: "updateSponsoringQuestionOnProject",

    /**
     *
     * @param props
     */
    value: function updateSponsoringQuestionOnProject(props) {
      var _this8 = this;

      var sponsoringQuestionFields = ['sponsoringquestion_id', 'sponsoringquestion_id2', 'sponsoringquestion_id3', 'sponsoringquestion_id4', 'sponsoringquestion_id5', 'sponsoringquestion_id6', 'sponsoringquestion_id7', 'sponsoringquestion_id8'];
      var sponsoringAnswersFields = ['sponsoranswer', 'sponsoranswer2', 'sponsoranswer3', 'sponsoranswer4', 'sponsoranswer5', 'sponsoranswer6', 'sponsoranswer7', 'sponsoranswer8'];

      var getIdQuestionFieldMap = function getIdQuestionFieldMap(project) {
        var idQuestionAnswered = [project.sponsoringquestion_id, project.sponsoringquestion_id2, project.sponsoringquestion_id3, project.sponsoringquestion_id4, project.sponsoringquestion_id5, project.sponsoringquestion_id6, project.sponsoringquestion_id7, project.sponsoringquestion_id8];
        var questionIdFieldNameMap = {};
        idQuestionAnswered.forEach(function (id, index) {
          if (id === 0 || id == null) return;
          questionIdFieldNameMap[id] = {
            fieldQuestion: sponsoringQuestionFields[index],
            fieldAnswer: sponsoringAnswersFields[index]
          };
        });
        return questionIdFieldNameMap;
      };

      var getQuestionById = function getQuestionById(idQuestion) {
        return _lodash.default.find(props.sponsoringQuestions, ['id', '' + idQuestion]);
      };

      var idQuestionFieldMap = getIdQuestionFieldMap(props.project);
      var idsAlreadyWithAnswer = Object.keys(idQuestionFieldMap).map(function (id) {
        return parseInt(id);
      }).filter(function (id) {
        return !isNaN(id);
      });
      var questionFieldsWithAnswer = Object.keys(idQuestionFieldMap).map(function (id) {
        return idQuestionFieldMap[id].fieldQuestion;
      });
      Object.keys(props.sponsoringAnswers).forEach(function (idQuestion) {
        idQuestion = parseInt(idQuestion);
        var question = getQuestionById(idQuestion);
        if (!question) return; //Ignore when question is not in the list, maybe is an outdated question

        var answer = props.sponsoringAnswers[idQuestion];

        if (idsAlreadyWithAnswer.indexOf(idQuestion) > -1) {
          // There is already an answer on this
          // Update the answer
          _this8.updateBrunchState(idQuestionFieldMap[idQuestion].fieldQuestion, idQuestion);

          if (question.question_type === '0') {
            //Radio button
            _this8.updateBrunchState(idQuestionFieldMap[idQuestion].fieldAnswer, answer.answerIndex);
          }

          if (question.question_type === '1' || question.question_type === '2') {
            // Input/TextBox
            _this8.updateBrunchState(idQuestionFieldMap[idQuestion].fieldAnswer, answer.answerValue);
          }

          return;
        } //There is no answer yet, add it to the brunch project


        for (var i = 0; i < sponsoringQuestionFields.length; i++) {
          var field = sponsoringQuestionFields[i];

          if (questionFieldsWithAnswer.indexOf(field) === -1) {
            if (question.question_type === '0') {
              //Radio button
              _this8.updateBrunchState(field, idQuestion);

              _this8.updateBrunchState(sponsoringAnswersFields[i], answer.answerIndex);
            }

            if (question.question_type === '1' || question.question_type === '2') {
              // Input/TextBox
              _this8.updateBrunchState(field, idQuestion);

              _this8.updateBrunchState(sponsoringAnswersFields[i], answer.answerValue);
            }

            break;
          }
        }
      });
    }
    /**
     *
     * @param data
     */

  }, {
    key: "updateFarmData",
    value: function updateFarmData(data) {
      this.setState(function (prev) {
        prev.farm = _lodash.default.assign(prev.farm, data);
        return prev;
      });
    }
    /**
     *
     * @param files
     * @param type
     */

  }, {
    key: "onFileUpload",
    value: function onFileUpload(files, type) {
      this.setState(function (prev) {
        prev.project[type] = prev.project[type].concat(files);
        return prev;
      });
    }
    /**
     *
     * @param file
     * @param type
     * @returns {Promise<void>}
     */

  }, {
    key: "onFileRemove",
    value: function onFileRemove(file, type) {
      var _this9 = this;

      return fetch(_conf.default.api.brunchApiRemoveFile(this.props.i18n.language, this.state.farm.id, this.state.project.id, file.id, type), {
        method: 'DELETE',
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this9.setState(function (prev) {
          prev.project[type] = prev.project[type].filter(function (projectFile) {
            return projectFile.id !== result.fileId;
          });
          return prev;
        });

        return Promise.resolve();
      });
    }
  }, {
    key: "getBrunchStatus",
    value: function getBrunchStatus(role, projects, is) {
      if (role === 'admin') return '';
      if (!projects.includes('brunch')) return 'online';
      if (role === 'projectresponsible') return '';
      return 'online';
    }
  }], [{
    key: "getIdQuestionFieldMap",
    value: function getIdQuestionFieldMap(project) {
      var idQuestionAnswered = [project.sponsoringquestion_id, project.sponsoringquestion_id2, project.sponsoringquestion_id3, project.sponsoringquestion_id4, project.sponsoringquestion_id5, project.sponsoringquestion_id6, project.sponsoringquestion_id7, project.sponsoringquestion_id8];
      var questionIdFieldNameMap = {};
      var sponsoringQuestionFields = ['sponsoringquestion_id', 'sponsoringquestion_id2', 'sponsoringquestion_id3', 'sponsoringquestion_id4', 'sponsoringquestion_id5', 'sponsoringquestion_id6', 'sponsoringquestion_id7', 'sponsoringquestion_id8'];
      var sponsoringAnswersFields = ['sponsoranswer', 'sponsoranswer2', 'sponsoranswer3', 'sponsoranswer4', 'sponsoranswer5', 'sponsoranswer6', 'sponsoranswer7', 'sponsoranswer8'];
      idQuestionAnswered.forEach(function (id, index) {
        if (id === 0 || id == null) return;
        questionIdFieldNameMap[id] = {
          fieldQuestion: sponsoringQuestionFields[index],
          fieldAnswer: sponsoringAnswersFields[index]
        };
      });
      return questionIdFieldNameMap;
    }
    /**
     *
     * @param project
     */

  }, {
    key: "getAnswersMap",
    value: function getAnswersMap(project) {
      var answers = {};
      var idQuestionAnswered = [project.sponsoringquestion_id, project.sponsoringquestion_id2, project.sponsoringquestion_id3, project.sponsoringquestion_id4, project.sponsoringquestion_id5, project.sponsoringquestion_id6, project.sponsoringquestion_id7, project.sponsoringquestion_id8];
      var answerOFQuestionAnswered = [project.sponsoranswer, project.sponsoranswer2, project.sponsoranswer3, project.sponsoranswer4, project.sponsoranswer5, project.sponsoranswer6, project.sponsoranswer7, project.sponsoranswer8];
      idQuestionAnswered.forEach(function (id, index) {
        if (id === 0) return;
        answers[id] = {
          answerIndex: !isNaN(parseInt(answerOFQuestionAnswered[index])) ? answerOFQuestionAnswered[index] : undefined,
          answerValue: answerOFQuestionAnswered[index]
        };
      });
      return answers;
    }
    /**
     *
     * @param project
     */

  }, {
    key: "removeEmptySingleRelation",
    value: function removeEmptySingleRelation(project) {
      var singleRelations = ['foreignorganizator', 'ownforeignorganizator', 'farmforeignorganizator'];
      singleRelations.forEach(function (singleRelation) {
        var singleRelationValue = _lodash.default.get(project, singleRelation);

        if (singleRelationValue && _lodash.default.isArray(singleRelationValue) && singleRelationValue.length === 0) {
          _lodash.default.set(project, singleRelation, {});
        }
      });
      return project;
    }
  }]);

  return Release;
}(_react.default.Component);

Release.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      farmId: _propTypes.default.string
    })
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  }),
  getSubMenuConfig: _propTypes.default.func
};

var _default = (0, _translate.default)(Release);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/brunch-release/release.js
// module id = 505
// module chunks = 0